import type { OpenAiAdsEvent, OpenAiAdsEventConfig } from '~/types/openai-ads'

declare const window: Window | undefined

export function openAIAdsTrack(eventName: string, eventProps?: OpenAiAdsEvent, eventOptions?: OpenAiAdsEventConfig) {
  window?.oaiq?.('measure', eventName, eventProps, eventOptions)
}
